import PropTypes from "prop-types";
import React from "react";
import { Card, CardText, CardTitle } from "react-md/lib/Cards";

class OrderConfirmation extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    const {
      lastLoanNumber,
    } = this.props;
    
    return (
      <div className="case-header">
        <Card>
          <CardTitle title="Thank you for your order"/>
          <CardText className="md-grid">
            Your loan number is {lastLoanNumber}. You will receive a confirmation e-mail shortly. 
          </CardText>
        </Card>
      </div>
    );
  }
}

OrderConfirmation.propTypes = {
  lastLoanNumber: PropTypes.string.isRequired
};

export default OrderConfirmation;
